import { Breadcrumbs, Button, Link, styled, Toolbar } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";

import { NavLink } from "components/navigation/NavLink";

interface Props {}

export function AppBreadcrumbs(props: Props) {
  const { t } = useTranslation();
  const { uuid } = useParams();
  const { pathname } = useLocation();
  const planMeasurementActiveState =
    pathname.includes("measure") || pathname.includes("group");
  const isResultPage =
    pathname.includes("result") || pathname.includes("progress");

  return (
    <Styles variant="dense">
      <Button
        className="main-button"
        variant="breadcrumb"
        component={NavLink}
        to={uuid ? `/${uuid}` : "/"}
      >
        {t("label.projectTool")}
      </Button>
      <Breadcrumbs separator="›">
        <Link
          component={NavLink}
          variant="breadcrumb"
          to={uuid ? `/${uuid}` : "/"}
          end
        >
          {t("label.studyArea")}
        </Link>
        <Link
          className={uuid ? "enabled" : "disabled"}
          component={NavLink}
          variant="breadcrumb"
          to={`/${uuid}/climate-effects`}
          end
        >
          {t("label.climateChallenges")}
        </Link>
        <Link
          className={`${uuid ? "enabled" : "disabled"} ${
            planMeasurementActiveState ? "active" : ""
          }`}
          component={NavLink}
          variant="breadcrumb"
          to={`/${uuid}/measures`}
          end
        >
          {t("label.measures")}
        </Link>

        <Link
          className={` ${isResultPage ? "active" : "disabled"}`}
          component={NavLink}
          variant="breadcrumb"
          to={`/${uuid}/result`}
          end
        >
          {t("label.myResult")}
        </Link>
      </Breadcrumbs>
    </Styles>
  );
}

const Styles = styled(Toolbar)`
  flex-grow: 1;

  .main-button {
    margin-right: ${({ theme }) => theme.spacing(2)};
  }

  .MuiBreadcrumbs-root {
    display: inline-block;
  }
  .disabled {
    pointer-events: none;
    color: inherit;
  }
`;
